import React from 'react';
import { TextField } from '@mui/material';
import { useController, UseControllerProps } from 'react-hook-form';
import { InputProps as StandardInputProps } from '@mui/material/Input/Input';

type StandardFieldProps = {
  controllerInitialState: UseControllerProps<any>;
  label: string;
  inputAdornment?: Partial<StandardInputProps>;
  type?: React.InputHTMLAttributes<unknown>['type'];
};

export const StandardField: React.FC<StandardFieldProps> = ({
  controllerInitialState,
  label,
  inputAdornment,
  type = 'text',
}) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController(controllerInitialState);

  return (
    <TextField
      fullWidth={true}
      inputProps={{
        'data-testid': controllerInitialState.name,
      }}
      label={label}
      variant={'outlined'}
      value={value}
      type={type}
      onChange={onChange}
      error={!!error}
      helperText={error ? error.message : null}
      InputProps={inputAdornment || undefined}
    />
  );
};
